import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ReportPropertyDetailConstant } from '../../residential-property/residential-property-detail.constant';
import { ReportPropertyDetailService } from '../../residential-property/residential-property-detail.service';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from 'src/app/reports/services/report.service';
import { ReportTableDropdown } from 'src/app/reports/components/reports-lists/models/reports.model';
import { SharedService } from 'src/app/common/services/shared.service';

@Component({
  selector: 'app-unit-transaction',
  templateUrl: './unit-transaction.component.html',
  styleUrls: ['./unit-transaction.component.scss']
})
export class UnitTransactionComponent implements OnChanges {
  @Output() isEmpatyCheck: any = new EventEmitter();
  @Input() propertyInfo: any;
  unitTransactionLoading = false;
  unitTransactionData = [];
  unitTransactionCount = 0;
  unitTransactionPropertyColumns  = ReportPropertyDetailConstant.unitTransactionPropertyColumns;
  transTypes:any[] = [];
  actualCount: number = 0;
  auctionCount : number = 0;
  quoteCount : number = 0;
  transactionType: ReportTableDropdown = {
    label: "reports.transactionType",
    data: [{
      value: 'Actual',
      id: 'Actual'
    }, {
      value: 'Auction',
      id: 'Auction'
    }, {
      value: 'Quote',
      id: 'Quote'
    }],
    default: "Actual",
    maxSelect: 3,
    reportType: true
  }
  constructor(public reportPropertyDetailService: ReportPropertyDetailService,
    private translate : TranslateService,
    public reportService: ReportService,
    private sharedService: SharedService
  ){}

  ngOnChanges(): void {
    this.transTypes = this.transactionType.data.map(e=> {return e.id});
    this.sharedService.language$.subscribe({
      next : (res: any) => {
        this.getUnitTransaction(this.transTypes.toString());
      },
      error : (err:any) => { }
    })

  }

  getUnitTransaction(type:string = "") {
    this.unitTransactionLoading = true;
    this.reportPropertyDetailService.getUnitTransctionReport(this.reportPropertyDetailService.unitTransactionPayload, type).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            this.isEmpatyCheck.emit(true)
            this.actualCount = res.actual_count;
            this.auctionCount = res.auction_count
            this.quoteCount = res.quote_count
            this.unitTransactionData = res.data;
          //   this.unitTransactionData = res.data.map((value: any) => {
          //   value['transaction_date']= value.transaction_date ? moment.utc(value.transaction_date).local().format('DD MMM YYYY') : null;
          //   value['value'] = this.reportType(value);
          //   if(value?.source_name)
          //     value['transaction_type'] = `${value.transaction_type} (${value.source_name})`
          //   return value;
          // })
            if(this.reportPropertyDetailService.unitTransactionPayload.pageNumber == 0){
            this.unitTransactionCount = res.count;
           }

          } else {
            this.isEmpatyCheck.emit(false)
            this.unitTransactionData = [];
            this.unitTransactionCount = 0;
            this.actualCount = 0;
            this.auctionCount = 0;
            this.quoteCount = 0;
          }
          this.unitTransactionLoading = false;
        },
        error:()=>{
          this.isEmpatyCheck.emit(false)
          this.unitTransactionLoading = false;
          this.unitTransactionData = [];
          this.unitTransactionCount = 0;
          this.actualCount = 0;
          this.auctionCount = 0;
          this.quoteCount = 0;
        }
      }
    )
  }



  onPageEvent(e: any) {
    this.reportPropertyDetailService.unitTransactionPayload.pageNumber = (e.pageSize * e.pageIndex);
    this.getUnitTransaction(this.transTypes.toString());
  }

  sortData(event: any) {
    let sort = {
      column: event.active,
      order: event.direction
    }
    this.reportPropertyDetailService.unitTransactionPayload.pageNumber = 0;
    this.reportPropertyDetailService.unitTransactionPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
    this.getUnitTransaction(this.transTypes.toString());
  }

  downloadExcel(event: any, type: string) {
    this.reportPropertyDetailService.downloadRentalReport(type, 'residential' ,this.propertyInfo?.property_uid, 'b');
  }

  reportType(value: any): string {
    let recordType = `<div class="reportType-value">${value.value ? this.reportService.numFormat(value.value): ''}</div>`;
    if (value?.prop_type_govt && value?.prop_type_estater && value?.prop_type_govt !== value?.prop_type_estater) {
      recordType += `<div class="reportType-land"><del>${this.translate.instant(value?.prop_type_govt)}</del><span class='reportType'>*${this.translate.instant(value?.prop_type_estater)}</span></div>`;
    } else if (value?.prop_type_govt) {
      recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_govt)}</div>`;
    } else if (value?.prop_type_estater) {
      recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_estater)}</div>`;
    }
    return recordType;
  }

  selectionChange(value: any) {
    this.transTypes = value;
    this.getUnitTransaction(this.transTypes.toString());
  }

}
